// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3vWIf","consentsList":"PatientConsents_consentsList__1utq8","consentsListEmpty":"PatientConsents_consentsListEmpty__Xq00e"};